import React, { Suspense, lazy } from 'react';
import ReactOnRails from 'react-on-rails';

// Eager: used on most pages (sidebar, listing search).
import Sidebar from 'bundles/components/Sidebar';
import SearchBar from 'bundles/components/SearchBar'

const lazyComponent = (Component) => (props) =>
  React.createElement(
    Suspense,
    {
      fallback: React.createElement('div', {
        className: 'loading-placeholder',
        style: { minHeight: '10px' },
      }),
    },
    React.createElement(Component, props)
  );

const CopyToClipboard = lazy(() => import('bundles/components/CopyToClipboard'));
const DateTime24Input = lazy(() => import('bundles/form/components/DateTime24Input'));
const DynamicForm = lazy(() => import('bundles/form/components/DynamicForm'));
const EmailListInput = lazy(() => import('bundles/form/components/EmailListInput'));
const EventsPrice = lazy(() => import('bundles/events/form/EventsPrice'));
const EventsSchedule = lazy(() => import('bundles/events/form/EventsSchedule'));
const GoogleMapsApi = lazy(() => import('bundles/components/GoogleMapsApi'));
const PasswordChange = lazy(() => import('bundles/form/components/PasswordChange'));
const PopUpDelete = lazy(() => import('bundles/components/PopUpDelete'));
const PreviewImage = lazy(() => import('bundles/components/PreviewImage'));
const QrPatternInput = lazy(() => import('bundles/form/components/QrPatternInput'));
const RichText = lazy(() => import('bundles/form/components/RichText'));
const ServiceFeeToggle = lazy(() => import('bundles/events/form/ServiceFeeToggle'));
const ThousandsInput = lazy(() => import('bundles/form/components/ThousandsInput'));

// This is how rails can see and use components
// We need to "register" all components in here
ReactOnRails.register({
  Sidebar,
  SearchBar,

  CopyToClipboard: lazyComponent(CopyToClipboard),
  DateTime24Input: lazyComponent(DateTime24Input),
  DynamicForm: lazyComponent(DynamicForm),
  EmailListInput: lazyComponent(EmailListInput),
  EventsPrice: lazyComponent(EventsPrice),
  EventsSchedule: lazyComponent(EventsSchedule),
  GoogleMapsApi: lazyComponent(GoogleMapsApi),
  PasswordChange: lazyComponent(PasswordChange),
  PopUpDelete: lazyComponent(PopUpDelete),
  PreviewImage: lazyComponent(PreviewImage),
  QrPatternInput: lazyComponent(QrPatternInput),
  RichText: lazyComponent(RichText),
  ServiceFeeToggle: lazyComponent(ServiceFeeToggle),
  ThousandsInput: lazyComponent(ThousandsInput),
});
